import { OneLineInput } from '../⚛️atoms/OneLineInput';
import { getTranslation, updateTranslation } from '../../utils/translationHelper';
import { TranslateButton } from '../atoms/translateButton';
import ReactPlayer from 'react-player';
import { cloneWorkbookV2Value } from './editorUtils';

export const WorkbookV2InlineVideo = ({ item, updateItem, editing, editingLanguage }) => {
  const updateEditorItem = (updates) => {
    const nextItem = cloneWorkbookV2Value(item);
    nextItem.text = updates.text ?? nextItem.text;
    nextItem.page_number = updates.page_number ?? nextItem.page_number;
    nextItem.translations = updates.translations ?? nextItem.translations;
    nextItem.options = {
      ...(nextItem.options ?? {}),
      ...(updates.options ?? {})
    };
    updateItem(nextItem);
  };

  return (
    <div className={`flex w-full items-center gap-2 ${editing && 'border-pdteal rounded-lg border-2 px-8 py-12'}`}>
      {!editing && (
        <div className='mx-auto w-4/5 aspect-video'>
          <ReactPlayer
            width='100%'
            height='100%'
            src={item.options?.target}
            onError={(error) => console.log(error)}
            controls={true}
          />
        </div>
      )}
      {editing && (
        <div className="grid w-full grid-cols-2 gap-8">
          <div className="relative">
            <OneLineInput label="Text" value={item.text} onChange={(value) => updateEditorItem({ text: value })} />
            {editingLanguage && (
              <TranslateButton
                text={item.text}
                language={editingLanguage}
                onResponse={(value) =>
                  updateEditorItem({
                    translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                  })
                }
              />
            )}
          </div>
          {editingLanguage && (
            <OneLineInput
              label={`Text (${editingLanguage})`}
              value={getTranslation(item.translations, editingLanguage, 'text')}
              onChange={(value) =>
                updateEditorItem({
                  translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                })
              }
            />
          )}
          <OneLineInput
            label="Target"
            value={item.options?.target}
            onChange={(value) => updateEditorItem({ options: { target: value } })}
          />
          <div className="w-2/5">
            <OneLineInput
              value={item.page_number}
              label="Page Number"
              onChange={(value) => updateEditorItem({ page_number: value })}
            />
          </div>
        </div>
      )}
    </div>
  );
};
